import { RoleDto } from '../../domain/roles/roles'
import API from '../api'

export type UserDto = {
  id: string
  url: string
  displayName: string
  email: string
  avatar: string
  prefix: string
  color: string
  sequence?: number
  isActive: boolean
  roles: string[]
  avatarDataBase64: string | null
  isSuperUser: boolean
  isFreeUser: boolean
  password?: string
}

export type ActiveUser = {
  email: string
  displayName: string
}

export const getUsers = async (): Promise<UserDto[]> => {
  return (await API.get<UserDto[]>('/users')).data
}

export const getDeletedUsers = async (): Promise<UserDto[]> => {
  return (await API.get<UserDto[]>('/users/deleted')).data
}

export const getActiveUsers = async (): Promise<ActiveUser> => {
  return (await API.get<ActiveUser>('/users/active')).data
}

export const getUser = async (email: string): Promise<UserDto> => {
  return (await API.get<UserDto>(`/users/${email}`)).data
}

export const getDeletedUser = async (email: string): Promise<UserDto> => {
  return (await API.get<UserDto>(`/users/deleted/${email}`)).data
}

export const updateUser = async (user: UserDto): Promise<UserDto> => {
  return (await API.post(`/users`, user)).data
}

export const updateUserPassword = async (email: string, newPassword: string, confirmNewPassword: string) => {
  await API.post(`/users/update-password`, { email, newPassword, confirmNewPassword })
}

export const deleteUser = async (email: string) => {
  await API.delete(`/users/${email}`)
}

export const restoreUser = async (email: string) => {
  await API.post(`/users/restore/${email}`)
}

export const validateUserEmail = async (email: string): Promise<boolean> => {
  return (await API.get(`/users/validate/${email}`)).data
}

export const getUsersRoles = async (): Promise<RoleDto[]> => {
  return (await API.get<RoleDto[]>('/users/roles')).data
}